<script>

	import { LayerCake, Svg, Html } from 'layercake';
	import { scaleOrdinal } from 'd3-scale';
	import { timeParse, timeFormat } from 'd3-time-format';
	import { format, precisionFixed } from 'd3-format';

	// import MultiLine from './MultiLine.svelte';
	import Bar from './Bar.svelte';

	import AxisX from './AxisX.svelte';
	import AxisY from './AxisY.svelte';
	import Labels from './Labels.svelte';
	import SharedTooltip from './SharedTooltip.svelte';
	import Select from 'svelte-select';

	import { onMount } from 'svelte';

	let has_mounted = false;

  
  let items = [
		{value: '97002', label: '97002 (Aurora)'},
		{value: '97003', label: '97003 (Beaverton)'},
		{value: '97004', label: '97004 (Beavercreek)'},
		{value: '97005', label: '97005 (Beaverton)'},
		{value: '97006', label: '97006 (Beaverton)'},
		{value: '97007', label: '97007 (Beaverton)'},
		{value: '97008', label: '97008 (Beaverton)'},
		{value: '97009', label: '97009 (Boring)'},
		{value: '97013', label: '97013 (Canby)'},
		{value: '97014', label: '97014 (Cascade Locks)'},
		{value: '97015', label: '97015 (Clackamas)'},
		{value: '97016', label: '97016 (Clatskanie)'},
		{value: '97017', label: '97017 (Colton)'},
		{value: '97018', label: '97018 (Columbia City)'},
		{value: '97019', label: '97019 (Corbett)'},
		{value: '97022', label: '97022 (Eagle Creek)'},
		{value: '97023', label: '97023 (Estacada)'},
		{value: '97024', label: '97024 (Fairview)'},
		{value: '97026', label: '97026 (Gervais)'},
		{value: '97027', label: '97027 (Gladstone)'},
		{value: '97030', label: '97030 (Gresham)'},
		{value: '97031', label: '97031 (Hood River)'},
		{value: '97032', label: '97032 (Hubbard)'},
		{value: '97034', label: '97034 (Lake Oswego)'},
		{value: '97035', label: '97035 (Lake Oswego)'},
		{value: '97038', label: '97038 (Molalla)'},
		{value: '97040', label: '97040 (Mosier)'},
		{value: '97041', label: '97041 (Mount Hood Parkdale)'},
		{value: '97042', label: '97042 (Mulino)'},
		{value: '97045', label: '97045 (Oregon City)'},
		{value: '97048', label: '97048 (Rainier)'},
		{value: '97049', label: '97049 (Rhododendron)'},
		{value: '97051', label: '97051 (Saint Helens)'},
		{value: '97053', label: '97053 (Warren)'},
		{value: '97055', label: '97055 (Sandy)'},
		{value: '97056', label: '97056 (Scappoose)'},
		{value: '97058', label: '97058 (The Dalles)'},
		{value: '97060', label: '97060 (Troutdale)'},
		{value: '97062', label: '97062 (Tualatin)'},
		{value: '97064', label: '97064 (Vernonia)'},
		{value: '97067', label: '97067 (Welches)'},
		{value: '97068', label: '97068 (West Linn)'},
		{value: '97070', label: '97070 (Wilsonville)'},
		{value: '97071', label: '97071 (Woodburn)'},
		{value: '97078', label: '97078 (Beaverton)'},
		{value: '97080', label: '97080 (Gresham)'},
		{value: '97086', label: '97086 (Happy Valley)'},
		{value: '97089', label: '97089 (Damascus)'},
		{value: '97101', label: '97101 (Amity)'},
		{value: '97103', label: '97103 (Astoria)'},
		{value: '97106', label: '97106 (Banks)'},
		{value: '97111', label: '97111 (Carlton)'},
		{value: '97113', label: '97113 (Cornelius)'},
		{value: '97114', label: '97114 (Dayton)'},
		{value: '97115', label: '97115 (Dundee)'},
		{value: '97116', label: '97116 (Forest Grove)'},
		{value: '97119', label: '97119 (Gaston)'},
		{value: '97121', label: '97121 (Hammond)'},
		{value: '97123', label: '97123 (Hillsboro)'},
		{value: '97124', label: '97124 (Hillsboro)'},
		{value: '97127', label: '97127 (Lafayette)'},
		{value: '97128', label: '97128 (Mcminnville)'},
		{value: '97132', label: '97132 (Newberg)'},
		{value: '97133', label: '97133 (North Plains)'},
		{value: '97137', label: '97137 (Saint Paul)'},
		{value: '97138', label: '97138 (Seaside)'},
		{value: '97140', label: '97140 (Sherwood)'},
		{value: '97141', label: '97141 (Tillamook)'},
		{value: '97146', label: '97146 (Warrenton)'},
		{value: '97148', label: '97148 (Yamhill)'},
		{value: '97201', label: '97201 (Portland)'},
		{value: '97202', label: '97202 (Portland)'},
		{value: '97203', label: '97203 (Portland)'},
		{value: '97204', label: '97204 (Portland)'},
		{value: '97205', label: '97205 (Portland)'},
		{value: '97206', label: '97206 (Portland)'},
		{value: '97209', label: '97209 (Portland)'},
		{value: '97210', label: '97210 (Portland)'},
		{value: '97211', label: '97211 (Portland)'},
		{value: '97212', label: '97212 (Portland)'},
		{value: '97213', label: '97213 (Portland)'},
		{value: '97214', label: '97214 (Portland)'},
		{value: '97215', label: '97215 (Portland)'},
		{value: '97216', label: '97216 (Portland)'},
		{value: '97217', label: '97217 (Portland)'},
		{value: '97218', label: '97218 (Portland)'},
		{value: '97219', label: '97219 (Portland)'},
		{value: '97220', label: '97220 (Portland)'},
		{value: '97221', label: '97221 (Portland)'},
		{value: '97222', label: '97222 (Portland)'},
		{value: '97223', label: '97223 (Portland)'},
		{value: '97224', label: '97224 (Portland)'},
		{value: '97225', label: '97225 (Portland)'},
		{value: '97227', label: '97227 (Portland)'},
		{value: '97229', label: '97229 (Portland)'},
		{value: '97230', label: '97230 (Portland)'},
		{value: '97231', label: '97231 (Portland)'},
		{value: '97232', label: '97232 (Portland)'},
		{value: '97233', label: '97233 (Portland)'},
		{value: '97236', label: '97236 (Portland)'},
		{value: '97239', label: '97239 (Portland)'},
		{value: '97266', label: '97266 (Portland)'},
		{value: '97267', label: '97267 (Portland)'},
		{value: '97301', label: '97301 (Salem)'},
		{value: '97302', label: '97302 (Salem)'},
		{value: '97303', label: '97303 (Salem)'},
		{value: '97304', label: '97304 (Salem)'},
		{value: '97305', label: '97305 (Salem)'},
		{value: '97306', label: '97306 (Salem)'},
		{value: '97317', label: '97317 (Salem)'},
		{value: '97321', label: '97321 (Albany)'},
		{value: '97322', label: '97322 (Albany)'},
		{value: '97325', label: '97325 (Aumsville)'},
		{value: '97327', label: '97327 (Brownsville)'},
		{value: '97330', label: '97330 (Corvallis)'},
		{value: '97331', label: '97331 (Corvallis)'},
		{value: '97333', label: '97333 (Corvallis)'},
		{value: '97338', label: '97338 (Dallas)'},
		{value: '97347', label: '97347 (Grand Ronde)'},
		{value: '97351', label: '97351 (Independence)'},
		{value: '97352', label: '97352 (Jefferson)'},
		{value: '97355', label: '97355 (Lebanon)'},
		{value: '97358', label: '97358 (Lyons)'},
		{value: '97361', label: '97361 (Monmouth)'},
		{value: '97362', label: '97362 (Mount Angel)'},
		{value: '97365', label: '97365 (Newport)'},
		{value: '97366', label: '97366 (South Beach)'},
		{value: '97367', label: '97367 (Lincoln City)'},
		{value: '97370', label: '97370 (Philomath)'},
		{value: '97374', label: '97374 (Scio)'},
		{value: '97375', label: '97375 (Scotts Mills)'},
		{value: '97378', label: '97378 (Sheridan)'},
		{value: '97380', label: '97380 (Siletz)'},
		{value: '97381', label: '97381 (Silverton)'},
		{value: '97383', label: '97383 (Stayton)'},
		{value: '97385', label: '97385 (Sublimity)'},
		{value: '97386', label: '97386 (Sweet Home)'},
		{value: '97389', label: '97389 (Tangent)'},
		{value: '97391', label: '97391 (Toledo)'},
		{value: '97392', label: '97392 (Turner)'},
		{value: '97394', label: '97394 (Waldport)'},
		{value: '97396', label: '97396 (Willamina)'},
		{value: '97401', label: '97401 (Eugene)'},
		{value: '97402', label: '97402 (Eugene)'},
		{value: '97403', label: '97403 (Eugene)'},
		{value: '97404', label: '97404 (Eugene)'},
		{value: '97405', label: '97405 (Eugene)'},
		{value: '97408', label: '97408 (Eugene)'},
		{value: '97411', label: '97411 (Bandon)'},
		{value: '97415', label: '97415 (Brookings)'},
		{value: '97419', label: '97419 (Cheshire)'},
		{value: '97420', label: '97420 (Coos Bay)'},
		{value: '97423', label: '97423 (Coquille)'},
		{value: '97424', label: '97424 (Cottage Grove)'},
		{value: '97426', label: '97426 (Creswell)'},
		{value: '97437', label: '97437 (Elmira)'},
		{value: '97438', label: '97438 (Fall Creek)'},
		{value: '97439', label: '97439 (Florence)'},
		{value: '97443', label: '97443 (Glide)'},
		{value: '97444', label: '97444 (Gold Beach)'},
		{value: '97446', label: '97446 (Harrisburg)'},
		{value: '97448', label: '97448 (Junction City)'},
		{value: '97455', label: '97455 (Pleasant Hill)'},
		{value: '97456', label: '97456 (Monroe)'},
		{value: '97457', label: '97457 (Myrtle Creek)'},
		{value: '97459', label: '97459 (North Bend)'},
		{value: '97462', label: '97462 (Oakland)'},
		{value: '97463', label: '97463 (Oakridge)'},
		{value: '97467', label: '97467 (Reedsport)'},
		{value: '97470', label: '97470 (Roseburg)'},
		{value: '97471', label: '97471 (Roseburg)'},
		{value: '97477', label: '97477 (Springfield)'},
		{value: '97478', label: '97478 (Springfield)'},
		{value: '97479', label: '97479 (Sutherlin)'},
		{value: '97487', label: '97487 (Veneta)'},
		{value: '97496', label: '97496 (Winston)'},
		{value: '97501', label: '97501 (Medford)'},
		{value: '97502', label: '97502 (Central Point)'},
		{value: '97503', label: '97503 (White City)'},
		{value: '97504', label: '97504 (Medford)'},
		{value: '97520', label: '97520 (Ashland)'},
		{value: '97523', label: '97523 (Cave Junction)'},
		{value: '97524', label: '97524 (Eagle Point)'},
		{value: '97525', label: '97525 (Gold Hill)'},
		{value: '97526', label: '97526 (Grants Pass)'},
		{value: '97527', label: '97527 (Grants Pass)'},
		{value: '97530', label: '97530 (Jacksonville)'},
		{value: '97532', label: '97532 (Merlin)'},
		{value: '97535', label: '97535 (Phoenix)'},
		{value: '97537', label: '97537 (Rogue River)'},
		{value: '97539', label: '97539 (Shady Cove)'},
		{value: '97540', label: '97540 (Talent)'},
		{value: '97601', label: '97601 (Klamath Falls)'},
		{value: '97603', label: '97603 (Klamath Falls)'},
		{value: '97623', label: '97623 (Bonanza)'},
		{value: '97624', label: '97624 (Chiloquin)'},
		{value: '97630', label: '97630 (Lakeview)'},
		{value: '97632', label: '97632 (Malin)'},
		{value: '97633', label: '97633 (Merrill)'},
		{value: '97641', label: '97641 (Christmas Valley)'},
		{value: '97701', label: '97701 (Bend)'},
		{value: '97702', label: '97702 (Bend)'},
		{value: '97703', label: '97703 (Bend)'},
		{value: '97707', label: '97707 (Bend)'},
		{value: '97720', label: '97720 (Burns)'},
		{value: '97734', label: '97734 (Culver)'},
		{value: '97738', label: '97738 (Hines)'},
		{value: '97739', label: '97739 (La Pine)'},
		{value: '97741', label: '97741 (Madras)'},
		{value: '97753', label: '97753 (Powell Butte)'},
		{value: '97754', label: '97754 (Prineville)'},
		{value: '97756', label: '97756 (Redmond)'},
		{value: '97759', label: '97759 (Sisters)'},
		{value: '97760', label: '97760 (Terrebonne)'},
		{value: '97761', label: '97761 (Warm Springs)'},
		{value: '97801', label: '97801 (Pendleton)'},
		{value: '97813', label: '97813 (Athena)'},
		{value: '97814', label: '97814 (Baker City)'},
		{value: '97818', label: '97818 (Boardman)'},
		{value: '97824', label: '97824 (Cove)'},
		{value: '97826', label: '97826 (Echo)'},
		{value: '97827', label: '97827 (Elgin)'},
		{value: '97828', label: '97828 (Enterprise)'},
		{value: '97836', label: '97836 (Heppner)'},
		{value: '97838', label: '97838 (Hermiston)'},
		{value: '97844', label: '97844 (Irrigon)'},
		{value: '97845', label: '97845 (John Day)'},
		{value: '97846', label: '97846 (Joseph)'},
		{value: '97850', label: '97850 (La Grande)'},
		{value: '97862', label: '97862 (Milton Freewater)'},
		{value: '97868', label: '97868 (Pilot Rock)'},
		{value: '97875', label: '97875 (Stanfield)'},
		{value: '97882', label: '97882 (Umatilla)'},
		{value: '97883', label: '97883 (Union)'},
		{value: '97885', label: '97885 (Wallowa)'},
		{value: '97886', label: '97886 (Weston)'},
		{value: '97913', label: '97913 (Nyssa)'},
		{value: '97914', label: '97914 (Ontario)'},
		{value: '97918', label: '97918 (Vale)'},
  ];

	 let selectedValue = '97918';
	// 
	import wholedata from './data/zips.js';


	function contains(a, zipstring) {
	    for (var i = 0; i < a.length; i++) {
	        if (a[i]["value"] == zipstring) {
	            return true;
	        }
	    }
	    return false;
	}



  	$: selectedValue, handleSelect(selectedValue);

  	let this_zip;


	if(window.location.hash) {

		var zipstring = window.location.href.split('#')[1]


		if (contains(items, zipstring)) {
			this_zip = zipstring;
			selectedValue = zipstring;

		} else {
			this_zip = '97236';
			selectedValue = '97236';
		}
    } else {
			this_zip = '97236';
			selectedValue = '97236';
	}	

	let data = wholedata[this_zip]["data"];

	let this_pop = wholedata[this_zip]["pop"];
	let this_first_date = wholedata[this_zip]["first_date"];
	let this_last_date = wholedata[this_zip]["last_date"];
	let this_cum_cases_start = wholedata[this_zip]["cum_cases_start"];
	let this_cum_cases_end = wholedata[this_zip]["cum_cases_end"];


	let xKey = 'm';
	let yKey = 'c';
	let zKey = 'k';

	let seriesNames = Object.keys(data[0]).filter(d => d !== xKey);
	let seriesColors = ['#ffe4b8', '#ffb3c0', '#ff7ac7', '#ff00cc'];

	const parseDate = timeParse('%Y-%m-%d');

	let dataLong = seriesNames.map(key => {
		return {
			key,
			values: data.map(d => {
				d[xKey] = typeof d[xKey] === 'string' ? parseDate(d[xKey]) : d[xKey]; // Conditional required for sapper
				return {
					key,
					[yKey]: +d[key],
					[xKey]: d[xKey]
				};
			})
		};
	});

	// Make a flat array of the `values` of our nested series
	// we can pluck the `value` field from each item in the array to measure extents
	const flatten = data => data.reduce((memo, group) => {
		return memo.concat(group.values);
	}, []);

	const formatTickX = timeFormat('%b. %e');
	//const formatTickY = d => format(`.${precisionFixed(d)}s`)(d);

	function formatTickY (d) {
	    if (d > 999) {
	      return d / 1000 + 'k';
	    }
	    return d;
	  }

	function handleSelect(newvalue) {


		if (newvalue.value) {
			var hash_name = "#" + newvalue.value;
	    
	   		history.pushState(null, null, hash_name);
	    	location.href = hash_name;
		}    


		if (newvalue.value === undefined) {
			return 0;
		}

		data = wholedata[newvalue.value]["data"];

		this_pop = wholedata[newvalue.value]["pop"];
		this_first_date = wholedata[newvalue.value]["first_date"]; 
		this_last_date = wholedata[newvalue.value]["last_date"];
		this_cum_cases_start = wholedata[newvalue.value]["cum_cases_start"];
		this_cum_cases_end = wholedata[newvalue.value]["cum_cases_end"];

		xKey = 'm';
		yKey = 'c';
		zKey = 'k';

		seriesNames = Object.keys(data[0]).filter(d => d !== xKey);
		seriesColors = ['#ffe4b8', '#ffb3c0', '#ff7ac7', '#ff00cc'];


		dataLong = seriesNames.map(key => {
			return {
				key,
				values: data.map(d => {
					d[xKey] = typeof d[xKey] === 'string' ? parseDate(d[xKey]) : d[xKey]; // Conditional required for sapper
					return {
						key,
						[yKey]: +d[key],
						[xKey]: d[xKey]
					};
				})
			};
		});

	}

	function format_number(num) {
	    var num_raw = num.toLocaleString()
	    var num_parts = num_raw.toString().split(".");
	    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    return num_parts.join(".");
  }




    onMount(() => {
    	// Assumes that pymchild is defined on the page before here! 
    	pymChild.sendHeight();
    	console.log("sending height");
  	});
</script>


<div class="header-container">
	<Select {items} bind:selectedValue></Select>
</div>
<div class="chartwrapper">
<div class="chart-container">
	<LayerCake
		padding={{ top: 7, right: 10, bottom: 20, left: 25 }}
		x={xKey}
		y={yKey}
		z={zKey}
		yDomain={[0, null]}
		zScale={scaleOrdinal()}
		zDomain={seriesNames}
		zRange={seriesColors}
		flatData={flatten(dataLong)}
		data={dataLong}
	>
		<Svg>
			<AxisX
				gridlines={false}
				ticks={3}
				formatTick={formatTickX}
				snapTicks={true}
			/>
			<AxisY
				ticks={5}
				formatTick={formatTickY}
			/>
			<Bar/>
		</Svg>

		<Html>
			<Labels/>

			<SharedTooltip
				formatTitle={formatTickX}
				dataset={data}
			/>
		</Html>
	</LayerCake>
</div>

<div class="header-container">
<p>ZIP code {selectedValue.label} has a population of { format_number(this_pop) } and reported { this_cum_cases_start } cases, cumulatively, by the week ending { this_first_date } and { format_number(this_cum_cases_end) } cases, cumulatively, as of { this_last_date }.</p>
<p>ZIP code data is from Esri's 2019 demographics update. COVID-19 case counts are from the Oregon Health Authority's weekly reports.</p>

</div>

</div>
